import { TenantLicenceRequest } from "../tenant/tenantLicenceRequest";

export class TenantLicenceStatus {
  isIncreaseProcessing: boolean | undefined;
  isDecreaseProcessing: boolean | undefined;
  tenantLicenceRequest: TenantLicenceRequest

  constructor(payload?: any) {
    if (payload) {
      this.isIncreaseProcessing = payload.isIncreaseProcessing;
      this.isDecreaseProcessing = payload?.isDecreaseProcessing;
      if(payload?.tenantLicenceRequest){
        this.tenantLicenceRequest = new TenantLicenceRequest(payload?.tenantLicenceRequest);
      }
    }
  }

  /**
   * creates users from a result
   * @param result Array of any
   * @returns Array of TenantLicenceRequest
   */
     static createTenantLicenceStatuses(result: Array<any>): TenantLicenceStatus[] {
      const requests = new Array<TenantLicenceStatus>();
      if (result) {
        result.map((request) => {
          requests.push(new TenantLicenceStatus(request));
        });
      }
      return requests;
    }
}
